import React, { useState } from "react";
import classes from "./FrequentlyAskedQuestions.module.scss";
import QuestionBlock from "./QuestionBlock.tsx";
import { Helmet } from "react-helmet-async";

export interface IQuestion {
  title: string;
  description: string;
  id: number;
}

const FrequentlyAskedQuestions = ({title, questions}:{title: string, questions: { left: IQuestion[]; right: IQuestion[] }}) => {


  const [openedBlockId, setOpenedBlockId] = useState<null | number>(null);

  const openBlockHandler = (id: number | null) => {
    setOpenedBlockId(id);
  };

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      ...questions.left.map(q => ({
        "@type": "Question",
        "name": q.title,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": q.description
        }
      })),
      ...questions.right.map(q => ({
        "@type": "Question",
        "name": q.title,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": q.description
        }
      }))
    ]
  };

  return (
      <div className={classes["container"]}>
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(faqJsonLd)}
          </script>
        </Helmet>

        <h2 className={classes["header"]}>
          {title}
        </h2>
        <div className={classes["blocks-container"]}>
          <div className={classes["left"]}>
            {questions.left.map(({ title, description, id }) => (
                <QuestionBlock
                    title={title}
                    description={description}
                    key={id}
                    id={id}
                    isOpened={id === openedBlockId}
                    openBlock={openBlockHandler}
                />
            ))}
          </div>
          <div className={classes["right"]}>
            {questions.right.map(({ title, description, id }) => (
                <QuestionBlock
                    title={title}
                    description={description}
                    key={id}
                    id={id}
                    isOpened={id === openedBlockId}
                    openBlock={openBlockHandler}
                />
            ))}
          </div>
        </div>
      </div>
  );
};

export default FrequentlyAskedQuestions;
